import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BilletLogService {

  constructor(private http: HttpClient) {}

  private readonly API_URL = environment.apiHost + '/api-log/secure/billet';

  getBilletStatusLogs(billetId: number): Observable<any> {
    return this.http.get(`${this.API_URL}/billet/${billetId}`).pipe(
      map((response: any) => response)
    );
  }

  getBilletStatusLogsByMarina(): Observable<any> {
    return this.http.get(`${this.API_URL}/marina`).pipe(
      map((response: any) => response)
    );
  }
}